// src/components/privacy/PrivacyHero.jsx
import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { FaShieldAlt, FaArrowRight } from 'react-icons/fa';

const PrivacyHero = () => {
  // Your background image URL
  const backgroundImage = "https://res.cloudinary.com/dgwnm39m7/image/upload/v1766823149/240_F_565929543_7GpxcjJ4cFJLckpMATIsSRbwFzZTvCJQ_l0gv6j.jpg";

  // Privacy policy date
  const lastUpdated = "March 15, 2026";

  return (
    <>
      {/* SEO Meta Tags for Privacy Policy Page */}
      <Helmet>
        <title>Privacy Policy | Data Protection | StayIN Centaurus Islamabad</title>
        <meta name="description" content="StayIN Centaurus privacy policy - Learn how we protect your personal data, your privacy rights, and our security measures. Last updated March 15, 2026. Trusted luxury serviced apartments in Islamabad." />
        <meta name="keywords" content="privacy policy StayIN, data protection Islamabad, privacy rights, personal data security, StayIN Centaurus privacy, GDPR compliance, guest data protection" />
        
        {/* Open Graph for Privacy Page */}
        <meta property="og:title" content="Privacy Policy | Data Protection | StayIN Centaurus Islamabad" />
        <meta property="og:description" content="Learn how StayIN protects your personal data. Your privacy rights and our security measures explained. Updated March 15, 2026." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://stayinhospitality.com/privacy-policy" />
        <meta property="og:image" content={backgroundImage} />
        <meta property="og:image:alt" content="StayIN Privacy Policy - Data Protection" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Privacy Policy | Data Protection | StayIN Centaurus" />
        <meta name="twitter:description" content="Learn how StayIN protects your personal data. Your privacy rights and our security measures explained." />
        
        {/* Robots - Allow indexing of privacy policy */}
        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* Privacy Policy Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Privacy Policy - StayIN Centaurus Serviced Apartments",
          "description": "Privacy policy and data protection practices for StayIN Centaurus Islamabad",
          "url": "https://stayinhospitality.com/privacy-policy",
          "dateModified": lastUpdated,
          "mainEntity": {
            "@type": "Organization",
            "name": "StayIN Centaurus Serviced Apartments",
            "legalName": "StayIN Hospitality",
            "description": "Luxury serviced apartments in Centaurus Islamabad",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Centaurus Complex, Jinnah Avenue",
              "addressLocality": "Islamabad",
              "addressCountry": "PK"
            },
            "privacyPolicy": "https://stayinhospitality.com/privacy-policy",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+92 303 4935404 ",
              "email": "privacy@stayin.com",
              "contactType": "privacy"
            }
          }
        })}
      </script>

      <section 
        className="relative h-screen flex items-center justify-center overflow-hidden"
        aria-label="Privacy Policy - Data Protection at StayIN Centaurus Islamabad"
      >
        {/* Background Image with Overlay */}
        <div 
          className="absolute inset-0 backgroundattachment bg-cover bg-no-repeat"
          style={{
            backgroundImage: `url('${backgroundImage}')`,
            backgroundPosition: "50% 50%",
          }}
        >
          {/* Dark overlay for text readability */}
          <div className="absolute inset-0 lg:bg-black/35 bg-black/50"></div>
        </div>

        {/* Content */}
        <div className="container-custom relative z-10">
          <div className="text-center text-white 2xl:space-y-8">
            {/* Main Heading */}
            <h1 className="text-5xl md:text-7xl 2xl:text-8xl font-bold mb-4 animate-fade-in-up animation-delay-200">
              Data <span className="font-bold text-[#c9a86c]">Privacy & Protection</span>
            </h1>

            {/* Description */}
            <p className="text-xl md:text-2xl 2xl:mb-10 mb-4 max-w-3xl mx-auto text-gray-200 animate-fade-in-up animation-delay-400">
              Your privacy is fundamental to our operations. This document outlines our data practices, your rights regarding your personal information, and the security measures we employ to protect your data.
            </p>

            {/* Last Updated */}
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20 animate-fade-in-up animation-delay-800">
              <span className="text-sm text-gray-300">Last Updated:</span>
              <span className="text-sm font-semibold text-[#c9a86c]">{lastUpdated}</span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyHero;